import en from './en.json';
import es from './es.json';

const messages = {
    en: en,
    es: es
};

export default messages;
